import { MutationType } from '@tencent/slide-sdk-pb-model';
import { BaseMutation } from '../base';
import { Rule } from '../base/mutation-rules';
import { merge } from '../../utils/protoutil';
import type { ICTBaseStyles } from '@tencent/slide-sdk-pb-model';
import type { PresentationDataModel } from '../../model/presentation-data-model';
import type { MaybeError } from '../base/base-mutation';
import type { IValidAddThemeMutationData, IValidRemoveThemeMutationData } from '../base/valid-mutation-data';

export class AddThemeMutation extends BaseMutation<PresentationDataModel, IValidAddThemeMutationData> {
    public readonly type: MutationType = MutationType.AddTheme;

    public apply(presentation: PresentationDataModel) {
        const { themeId, themeName, themeElements } = this.data;
        const styles: ICTBaseStyles = {};

        presentation.store.addTheme({
            id: themeId,
            name: themeName,
            themeElements: merge(styles, themeElements),
        });
    }

    public invert(): [IValidRemoveThemeMutationData] {
        return [
            {
                type: MutationType.RemoveTheme,
                themeId: this.data.themeId,
            },
        ];
    }

    public check(presentation: PresentationDataModel): MaybeError {
        const { themeId } = this.data;
        return Rule.every(
            () => Rule.model.should.notExist(presentation, themeId),
            () => Rule.theme.can.insertIntoThemeList(presentation, themeId),
        );
    }
}
